<template>
  <div class="all-is__container">
    <div class="all-is">
      <div class="all-is__logotype">
        All<span>(is)</span>
      </div>
      <transition-group name="fade">
        <div :key="currentIndex" class="all-is__rotator">
          <div v-if="phrases[currentIndex]">{{ phrases[currentIndex].text }}</div>
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mottos: { type: Array },
  },
  data() {
    return {
      currentIndex: 0,
      phrases: [],
    };
  },
  mounted() {
    this.phrases = this.mottos.filter(item => !item.status);
    this.currentIndex = this.getRandomIndex();
    this.startRotator();
  },
  methods: {
    startRotator() {
      setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.phrases.length;
      }, 3000); // Change the duration as needed
    },
    getRandomIndex() {
      return Math.floor(Math.random() * this.phrases.length);
    },
  },
};
</script>

<style lang="scss">
.all-is {
  body.home & {
    transform: translateX(var(--home-all-is-position-x));
  }
  &__container {
    grid-column: col-start 1 / col-end 2;
    position: relative;
    color: white;
    font-family: var(--fontSerifRg);
    font-size: 1.9rem;
    transition: color .5s ease;
    overflow: hidden;
  }
  &__logotype {
    span {
      font-family: var(--fontSerifIt);
    }
  }
  &__rotator {
    position: absolute;
    top: 0;
    left: 4rem;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    white-space: nowrap;
    & > div {
      position: relative;
      z-index: 1;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.header.light {
  .all-is {
    color: black;
  }
}

.header.dark {
  .all-is {
    color: white;
  }
}

</style>
